var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "contain" },
      [
        _c("img", {
          attrs: {
            src: require("@/assets/img/logo-shopvidi-new.png"),
            height: "40px",
            width: "160px"
          }
        }),
        _vm._v(" "),
        _c("el-divider"),
        _vm._v(" "),
        _c(
          "el-steps",
          {
            staticClass: "pc-steps",
            attrs: {
              active: _vm.active,
              "finish-status": "success",
              "align-center": ""
            }
          },
          [
            _c("el-step", { attrs: { title: "Register" } }),
            _vm._v(" "),
            _c("el-step", { attrs: { title: "Profile" } }),
            _vm._v(" "),
            _c("el-step", { attrs: { title: "Complete" } })
          ],
          1
        ),
        _vm._v(" "),
        _vm.active === 2
          ? _c("Profile", { on: { gotoReview: _vm.gotoReview } })
          : _vm._e(),
        _vm._v(" "),
        _vm.active === 3
          ? _c("BrandReviewResult", { attrs: { isApproved: _vm.isApproved } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2f9c57a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2f9c57a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/brand-review/brand-review.vue
// module id = CsTL
// module chunks = 2